var _defs, _circle, _path, _path2, _path3, _polygon, _polygon2, _g, _g2, _polygon3, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7FE306C4-B8C3-4A42-8E3B-5E7A97D97093") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Overview-&-Analytics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty-states---GMS",
    transform: "translate(-557.000000, -152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layout",
    transform: "translate(154.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(234.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "No-data",
    transform: "translate(111.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(59.000000, 0.000000)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E6E6E6",
    cx: 20.5,
    cy: 22.5,
    r: 20.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19,40.7912477 C26.4630072,40.7912477 39.0826978,35.0281457 38.5976725,23.7182872 C38,9.78171276 31.8919965,-1.09867703 22.5,2 C10.1671567,6.06894297 19,12 14,15.4225691 C9.26109522,18.666415 2,16.3047164 2,22.5 C2,33.8218374 11.5369928,40.7912477 19,40.7912477 Z",
    id: "Oval",
    fill: "url(#linearGradient-1)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29,20 L33,20 C34.1045695,20 35,20.8954305 35,22 L35,30 L35,30 L27,30 L27,22 C27,20.8954305 27.8954305,20 29,20 Z",
    id: "Rectangle-Copy-2",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19,10 L23,10 C24.1045695,10 25,10.8954305 25,12 L25,30 L25,30 L17,30 L17,12 C17,10.8954305 17.8954305,10 19,10 Z",
    id: "Rectangle-Copy",
    fill: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9,16 L13,16 C14.1045695,16 15,16.8954305 15,18 L15,30 L15,30 L7,30 L7,18 C7,16.8954305 7.8954305,16 9,16 Z",
    id: "Rectangle",
    fill: "#878787"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Star",
    fill: "#F39C1F",
    transform: "translate(13.000000, 6.000000) rotate(-20.000000) translate(-13.000000, -6.000000) ",
    points: "13 7 11.8244295 7.61803399 12.0489435 6.30901699 11.097887 5.38196601 12.4122147 5.19098301 13 4 13.5877853 5.19098301 14.902113 5.38196601 13.9510565 6.30901699 14.1755705 7.61803399"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Star-Copy",
    fill: "#F39C1F",
    transform: "translate(39.000000, 23.000000) rotate(20.000000) translate(-39.000000, -23.000000) ",
    points: "39 23.5 38.4122147 23.809017 38.5244717 23.1545085 38.0489435 22.690983 38.7061074 22.5954915 39 22 39.2938926 22.5954915 39.9510565 22.690983 39.4755283 23.1545085 39.5877853 23.809017"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.000000, 6.500000) rotate(20.000000) translate(-35.000000, -6.500000) translate(34.000000, 5.000000)",
    id: "Line",
    stroke: "#70AD47",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 2.5,
    x2: 2,
    y2: 2.5,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeWidth: 0.35,
    strokeLinejoin: "round",
    points: "2 0.549707467 1.3 1.47514627 0.414143285 1.01242687 0 1.47514627"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Cross-Icon-Copy",
    transform: "translate(4.500000, 11.500000) rotate(-20.000000) translate(-4.500000, -11.500000) translate(3.000000, 10.000000)",
    stroke: "#70AD47"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.6,
    y1: 0.6,
    x2: 1.6,
    y2: 2.6,
    id: "Line",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.6,
    y1: 1.6,
    x2: 2.6,
    y2: 1.6,
    id: "Line",
    strokeWidth: 0.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 0.3,
    fill: "#E4F2DA",
    cx: 1.6,
    cy: 1.6,
    r: 1
  }))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Triangle",
    fill: "#4472C4",
    transform: "translate(23.500000, 4.050000) rotate(20.000000) translate(-23.500000, -4.050000) ",
    points: "23.5 3 25 5.1 22 5.1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 31.5,
    x2: 36,
    y2: 31.5,
    id: "Line-3",
    stroke: "#878787",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.3e85af35adab053330e33c68aa93d5a2.svg";
export { ForwardRef as ReactComponent };